import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Header from '@/travo/components/layout/Header/Header';
import Footer from '@/travo/components/layout/Footer/Footer';
import { DocumentLang } from '@/app/DocumentLang';
import { useCopy } from '@/travo/i18n';
import { PAPER_PATTERN } from '@/travo/theme/constants';

/** Travo's pages under /travo: sticky header, the page, footer, on paper grain. */
const TravoLayout = () => (
  <>
    <DocumentLang lang={useCopy().htmlLang} />
    <Box {...PAPER_PATTERN.grain} minH="100vh">
      <Header />
      <Outlet />
      <Footer />
    </Box>
  </>
);

export default TravoLayout;
